"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawingColorDestinationBase = void 0;
var tslib_1 = require("tslib");
var map_creator_1 = require("../../../../../base-utils/map-creator");
var destination_1 = require("../../destination");
var h_slcolor_destination_1 = require("./h-slcolor-destination");
var hex_rgbcolor_destination_1 = require("./hex-rgbcolor-destination");
var percentage_rgbcolor_destination_1 = require("./percentage-rgbcolor-destination");
var preset_color_destination_1 = require("./preset-color-destination");
var scheme_color_destination_1 = require("./scheme-color-destination");
var system_color_destination_1 = require("./system-color-destination");
var DrawingColorDestinationBase = (function (_super) {
    tslib_1.__extends(DrawingColorDestinationBase, _super);
    function DrawingColorDestinationBase(data, color) {
        var _this = _super.call(this, data) || this;
        _this.color = color;
        _this.hasColor = false;
        return _this;
    }
    DrawingColorDestinationBase.getColor = function (data) {
        var destination = data.destinationStack.getThis();
        destination.hasColor = true;
        return destination.color;
    };
    DrawingColorDestinationBase.handlerTable = new map_creator_1.MapCreator()
        .add('hslClr', function (data) { return new h_slcolor_destination_1.HSLColorDestination(data, DrawingColorDestinationBase.getColor(data)); })
        .add('prstClr', function (data) { return new preset_color_destination_1.PresetColorDestination(data, DrawingColorDestinationBase.getColor(data)); })
        .add('schemeClr', function (data) { return new scheme_color_destination_1.SchemeColorDestination(data, DrawingColorDestinationBase.getColor(data)); })
        .add('scrgbClr', function (data) { return new percentage_rgbcolor_destination_1.PercentageRGBColorDestination(data, DrawingColorDestinationBase.getColor(data)); })
        .add('srgbClr', function (data) { return new hex_rgbcolor_destination_1.HexRGBColorDestination(data, DrawingColorDestinationBase.getColor(data)); })
        .add('sysClr', function (data) { return new system_color_destination_1.SystemColorDestination(data, DrawingColorDestinationBase.getColor(data)); })
        .get();
    return DrawingColorDestinationBase;
}(destination_1.ElementDestination));
exports.DrawingColorDestinationBase = DrawingColorDestinationBase;
